import * as React from 'react';
import { DetailFormProvider } from '../components/DetailFormProvider';
export const DetailProvider = () => {
  return <DetailFormProvider />;
};
